import { audiencerateApi } from '../audiencerate';

export const templateImagesApi = audiencerateApi.injectEndpoints({
  endpoints: (build) => ({
    // The file goes as the raw body: fetchBaseQuery only JSON-encodes plain objects/arrays.
    uploadTemplateImage: build.mutation<{ url: string }, { workspaceId: string; file: File }>({
      query: ({ workspaceId, file }) => ({
        url: `/v1/workspace/${workspaceId}/template-images`,
        method: 'POST',
        body: file,
        headers: { 'Content-Type': file.type },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useUploadTemplateImageMutation } = templateImagesApi;
